import { Link } from "react-router-dom";
import { Mail, MessageCircle, Building2 } from "lucide-react";
import { useSettings, whatsappLink } from "../../context/SettingsContext";

export const MobileBar = () => {
  const s = useSettings();
  const item = "flex-1 flex flex-col items-center justify-center gap-1 py-3 text-[10px] uppercase tracking-[0.18em]";
  return (
    <div data-testid="mobile-cta-bar" className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-ink/95 backdrop-blur-xl text-cream border-t border-white/10 flex">
      <Link to="/contatti" data-testid="mobile-bar-contatti" className={item}><Mail size={18} strokeWidth={1.5} />Contatti</Link>
      <a href={whatsappLink(s)} target="_blank" rel="noreferrer" data-testid="mobile-bar-whatsapp" className={`${item} text-sage-light border-x border-white/10`}><MessageCircle size={18} strokeWidth={1.5} />WhatsApp</a>
      <Link to="/proponi-immobile" data-testid="mobile-bar-proponi" className={item}><Building2 size={18} strokeWidth={1.5} />Proponi</Link>
    </div>
  );
};
